module.exports = __webpack_public_path__ + "img/arrow_exchange.daca25ab.svg";